import * as request from './utils/requester';

export const getAll = (page) => request.get(`/schedule?page=${page}`);

export const getById = (id) => request.get(`/schedule/${id}`);

export const create = (data) => request.post('/schedule', data);

export const edit = (data) => request.put(`/schedule/${data._id}`, data);

export const del = (id) => request.del(`/schedule/${id}`);
// export const del = (data) => request.del(`/schedule/${data._id}`);


export const getOption = (option) => request.get(`/schedule?option=${option}`);